module.exports = __webpack_public_path__ + "static/img/lock-screen.a5c1191d.png";